import { render, staticRenderFns } from "./OceanoDrinkSection.vue?vue&type=template&id=2447a0c7&scoped=true"
import script from "./OceanoDrinkSection.vue?vue&type=script&lang=ts"
export * from "./OceanoDrinkSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoDrinkSection.vue?vue&type=style&index=0&id=2447a0c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447a0c7",
  null
  
)

export default component.exports